import { useTranslation } from "react-i18next";
import { useState, useEffect, useContext, useRef } from "react";
import { GlobalContext } from "../context/GlobalContext";
import { Typography, ConfirmModal } from "mobily-ui-library/lib";
import { JSEncrypt } from 'jsencrypt';

import Loader from "../components/Loader/Loader";
import CartPage from "../components/CartPage/CartPage";
import EmptyCartPage from "../components/EmptyCartPage/EmptyCartPage";
import StickyPriceBar from "../components/StickyPriceBar/StickyPriceBar";
import DeviceLogin from "../components/DeviceLogin/DeviceLogin";
import ErrorModal from "../components/ErrorModal/ErrorModal";
import DeviceOTP from "../components/DeviceOTP/DeviceOTP";
import DeviceTerms from "../components/DeviceTerms/DeviceTerms";
import TermsOTP from "../components/TermsOTP/TermsOTP";
import TwoYearCoverageLogin from "../components/TwoYearCoverageLogin/TwoYearCoverageLogin";

import getCookies from "../Util/getCookies";
import { deleteCookie } from "../Util/deleteCookies";
import { updateAndValidateSc, cancelShoppingcart, cemInitiateOTP, getProjectionCheckoutBySCId } from "../api/api";

import { handleApiError } from '../functions/handleApiError';

import './Pages.scss';

const win: any = window;
// const serverURL = win['base_portal_url'];
// const errorPage = win['errorPageURL'];

function Pages() {
    const { t } = useTranslation();
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, outOfStock, currentPage, scData } = state;

    const childRef: any = useRef();

    const [emptyFlag, setEmptyFlag] = useState(false);
    const [shoppingCartId, setShoppingCartId] = useState<any>("");
    const [productId, setProductId] = useState("");
    const [againGraphQl, setAgainGraphQl] = useState<any>(false);
    const [tamaraFee, setTamaraFee] = useState('');
    const [errorCode, setErrorCode] = useState('');
    const [isCemInitiateOTPGenericError, setIsCemInitiateOTPGenericError] = useState(false);
    const [isCemInitiateOTPError, setIsCemInitiateOTPError] = useState(false);
    const [timer, setTimer] = useState(0);
    const [isLoginOTPError, setisLoginOTPError] = useState(false);
    const [isLoginStatusCode, setIsLoginStatusCode] = useState(false);
    const [showDiscardAppleCare, setShowDiscardAppleCare] = useState<any>(false);

    const [transId, setTransId] = useState('');
    const [errCode, setErrCode] = useState('');

    useEffect(() => {
        console.log('---Cart Page---')
        const cookieScId: any = window.location.href.includes("localhost") ?
            "3048c111-6162-4228-ab16-f829d7068aae" : getCookies('device-scId');
        const cookieXCoId: any = window.location.href.includes("localhost") ?
            "PORC250908113033775_85530" : getCookies('device-xCoId');
        setShoppingCartId(cookieScId);
        !!!win["xCoId"] && (win["xCoId"] = cookieXCoId);
        !!!win['shoppingCartId'] && (win['shoppingCartId'] = cookieScId);
        dispatch({ type: 'XCOID', payload: { xCoId: cookieXCoId } });
    }, [dispatch]);

    useEffect(() => {
        if (shoppingCartId?.length > 0) {
            dispatch({ type: 'LOADER', payload: { loading: true } })
            updateAndValidateSc(shoppingCartId)
                .then((res: any) => {
                    if (res.status === 200 && res.data) {
                        if (res.data?.shoppingCart?.cartTotalPrice) {
                            setEmptyFlag(true)
                            dispatch({ type: "SC_RESPONSE", payload: { scData: res.data?.shoppingCart } })
                            setProductId(res.data?.shoppingCart?.offerContainer[0].cartItem[0].productOffering.id);
                            const appleCare = res.data?.shoppingCart?.offerContainer[0].cartItem?.filter((item: any) => {
                                if (item?.product?.name.includes("AppleCare+ warranty one time")) {
                                    return item;
                                } else if (item?.product?.name.includes("AppleCare+ warranty recurring")) {
                                    return item;
                                }
                            })?.[0];
                            const acName = appleCare?.product?.name;
                            const acId = appleCare?.productOffering?.id;
                            const acPrice = appleCare?.itemTotalPrice?.[0]?.price?.taxIncludedAlteredAmount?.value;
                            const acObj = { acId: acId, acName: acName, price: acPrice };

                            const priceAlterationArray = res.data?.shoppingCart?.offerContainer[0]?.cartItem[0]?.itemPrice[0]?.priceAlteration
                            const priceAlterationType = priceAlterationArray ? priceAlterationArray[0]?.priceAlterationType : "";
                            const isSubsidy = priceAlterationType === "promotion" ? true : false;
                            const isInstallment = priceAlterationType === "manualPriceOverride" ? true : false;
                            dispatch({ type: 'APPLECARE_APPLIED', payload: { appleCareApplied: acName ? true : false } });
                            dispatch({ type: "SELECTED_AC_PLAN", payload: { selectedAcPlan: acObj } });
                            dispatch({ type: 'IS_SUBSIDY_APPLIED', payload: { isSubsidyApplied: isSubsidy } });
                            dispatch({ type: 'IS_INSTALLMENT_APPLIED', payload: { isInstallmentApplied: isInstallment } });


                            //tamara fee only with update cart item[1] 
                            const tamaraItem = res.data?.shoppingCart?.offerContainer[0]?.cartItem.filter((item: any) => (item.product.name.toLowerCase() === 'tamara fee'));
                            if (tamaraItem.length > 0) {
                                const tamaraFee = tamaraItem[0].itemPrice[0].price.dutyFreeAlteredAmount.value;
                                setTamaraFee(tamaraFee.toString());
                            }

                            if (isSubsidy || isInstallment) {
                                getProjectionCheckoutBySCIdApi(res.data?.shoppingCart?.id, res.data?.shoppingCart?.validityToken);
                            } else {
                                dispatch({ type: 'LOADER', payload: { loading: false } })
                            }
                        } else {
                            dispatch({ type: 'LOADER', payload: { loading: false } })
                        }
                    } else if (res.status === 200 && res.data?.status?.sourceCode === "1111") {
                        deleteCookie('device-count');
                        deleteCookie('device-scId');
                        deleteCookie('device-xCoId');
                        deleteCookie('device-poid');
                        deleteCookie('device-journeyName');
                        win.updateCartItemCount(0);
                        dispatch({ type: 'LOADER', payload: { loading: true } })
                        cancelShoppingcartApi(shoppingCartId);
                    } else {
                        deleteCookie('device-count');
                        deleteCookie('device-scId');
                        deleteCookie('device-xCoId');
                        deleteCookie('device-poid');
                        deleteCookie('device-journeyName');
                        win.updateCartItemCount(0);
                        setEmptyFlag(false);
                        dispatch({ type: 'LOADER', payload: { loading: false } });
                    }
                }).catch(err => {
                    deleteCookie('device-count');
                    deleteCookie('device-scId');
                    deleteCookie('device-xCoId');
                    deleteCookie('device-poid');
                    deleteCookie('device-journeyName');
                    if (win?.updateCartItemCount) {
                        win?.updateCartItemCount(0);
                    }
                    setEmptyFlag(false);
                    dispatch({ type: 'LOADER', payload: { loading: false } });
                })
        }
    }, [dispatch, shoppingCartId, t])

    const handleCheckout = () => {
        setAgainGraphQl(true);
    };

    const handleLoginSubmit = (number: string, userID: string) => {
        const lang = rtl ? 'ar' : 'en';
        cemCallInitiateOTPApi(number, userID, lang)
        dispatch({ type: "LOADER", payload: { loading: true } });
    }

    const handleLoginCLose = () => {
        setShowDiscardAppleCare(true)
    }

    const handleModalGotIt = () => {
        setIsCemInitiateOTPError(false);
        setIsCemInitiateOTPGenericError(false);
    }

    const cancelShoppingcartApi = (shoppingCartId: any) => {
        cancelShoppingcart(shoppingCartId)
            .then((response: any) => {
                if (response?.status === 200) {
                    window.location.href = win["productUrl"];
                }
            }).catch(err => {
                const config = Object.assign(err?.config, { serviceName: 'cancelShoppingCart' });
                const error = { ...err, config }
                handleApiError(error);
            })
    }

    const handleTryAgain = () => {
        setisLoginOTPError(false);
    }

    const cemCallInitiateOTPApi = (msisdn: any, userID: any, lang: any) => {
        // const publicKey = win['public_key'];
        const cemPublicKey = win['cem_public_key'];
        const jsencrypt = new JSEncrypt();
        jsencrypt.setPublicKey(cemPublicKey);

        const msisdnVal = msisdn.length > 0 ? msisdn.replace(/^0/, '966') : '';
        const mobileNumber = jsencrypt.encrypt(msisdnVal);
        const idNumber = jsencrypt.encrypt(userID);

        cemInitiateOTP(mobileNumber, idNumber, lang)
            .then((res: any) => {
                setErrorCode(res?.data?.status?.sourceCode ? res?.data?.status?.sourceCode : res?.status);
                if (res?.status === 200 && res?.data) {
                    if (res?.data?.status?.sourceCode === 'MAPI-000') {
                        setTimer(120);
                        dispatch({ type: "LOADER", payload: { loading: false } });
                        dispatch({ type: 'INITATE_OTP_DATA', payload: { OTPData: res?.data } });
                        dispatch({ type: 'DEVICE_MOBILENUMBER', payload: { msisdn: msisdn.replace(/^966/, '0') } });
                        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'deviceOTP' } });
                    } else {
                        dispatch({ type: "LOADER", payload: { loading: false } });
                        const errCode = res?.status
                        setTransId(res?.config?.headers['X-Transaction-Id']);
                        setErrCode(errCode);
                        setIsCemInitiateOTPGenericError(true);
                    }
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    const errCode = res?.status
                    setTransId(res?.config?.headers['X-Transaction-Id']);
                    setErrCode(errCode);
                    setIsCemInitiateOTPGenericError(true);
                }
            }).catch(err => {
                if (err?.response) {
                    dispatch({ type: "LOADER", payload: { loading: false } });

                    if (err?.response?.status === 401 && err?.response?.data?.status?.sourceCode === 'MAPI-401-5') {
                        const errCode = err?.response?.status;
                        setTransId(err?.response?.config?.headers['X-Transaction-Id']);
                        setErrCode(errCode);
                        setIsCemInitiateOTPError(true);
                    } else
                        if (err?.response.status === 401 && err?.response?.data?.status?.sourceCode === 'MAPI-401-09') {
                            setisLoginOTPError(true);
                            setIsLoginStatusCode(true);
                        }
                        else
                            if (err?.response.status === 401 && err?.response?.data?.status?.sourceCode === 'MAPI-401-10') {
                                setisLoginOTPError(true);
                                setIsLoginStatusCode(false);
                            }
                            else {
                                const errCode = err?.response?.status
                                setTransId(err?.response?.config?.headers['X-Transaction-Id']);
                                setErrCode(errCode);
                                setIsCemInitiateOTPGenericError(true);
                            }
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    setIsCemInitiateOTPGenericError(true);
                }
            })
    }

    const getProjectionCheckoutBySCIdApi = (id: any, token: any) => {
        getProjectionCheckoutBySCId(id, token).then((response: any) => {
            if (response?.status === 200) {
                const otpVerificationData = response?.data?.sections.filter((section: any) => {
                    return (section.sectionId === 'DevicesOTPVerification')
                });
                const pNumber = otpVerificationData[0]?.steps[0]?.options[0]?.fields[0]?.value;
                const CustomerInfo = otpVerificationData[0]?.steps[0]?.fields[2]?.value;
                const newStack = otpVerificationData[0]?.steps[0]?.fields[8]?.value;
                dispatch({ type: "DEVICE_MOBILENUMBER", payload: { msisdn: pNumber } });
                dispatch({ type: "CUSTOMER_INFO", payload: { customerInfo: JSON.parse(CustomerInfo) } });
                dispatch({ type: "NEW_STACK", payload: { newStack: newStack } });
                dispatch({ type: 'LOADER', payload: { loading: false } });
            } else {
                handleApiError(response);
            }
        }).catch(err => {
            handleApiError(err);
        })
    }

    const poid = getCookies('device-poid');
    const xCoId = getCookies('device-xCoId');
    const journeyName = getCookies('device-journeyName');

    return (
        <>
            <div id="ecommerceJourneyName" style={{ display: "none" }}>{journeyName}</div>
            <div id="xCorrelationId" style={{ display: "none" }}>{xCoId}</div>
            <div id="sectionId" style={{ display: "none" }}>Cart</div>
            <div id="DeviceName" style={{ display: "none" }}>{poid}</div>
            <div id="monthly_pay" style={{ display: "none" }}>{poid}</div>
            <div id="upfront" style={{ display: "none" }}>{poid}</div>

            <Loader />
            {currentPage === "cartPage" && (<>
                <main className={rtl ? "container CartPage__Container CartPage__Right" : "container CartPage__Container"}>
                    <div className="CartPage__Header">
                        <Typography rtl={rtl} className="title">{t("Your_Cart")}</Typography>
                    </div>

                    {emptyFlag ? (
                        <CartPage
                            rtl={rtl}
                            productId={productId}
                            setShoppingCartId={setShoppingCartId}
                            againGraphQl={againGraphQl}
                            tamaraFee={tamaraFee}
                            setEmptyFlag={setEmptyFlag}
                        />
                    ) : (
                        <EmptyCartPage />
                    )}
                </main>

                {emptyFlag && (
                    <StickyPriceBar
                        rtl={rtl}
                        orderPriceData={scData}
                        handleCheckout={handleCheckout}
                        checkOutOfStock={outOfStock}
                    />
                )}
            </>)}

            <>
                {currentPage === 'login' &&
                    (<DeviceLogin
                        ref={childRef}
                        handleSubmit={handleLoginSubmit}
                        handleHeaderCancel={handleLoginCLose} />
                    )}

                {currentPage === 'deviceOTP' && (
                    <DeviceOTP
                        timer={timer}
                        setTimer={setTimer}
                        handleHeaderCancel={handleLoginCLose}
                    />
                )}

                {currentPage === 'TermsOTP' && (
                    <TermsOTP
                        handleHeaderCancel={handleLoginCLose}
                    />
                )}

                {currentPage === 'DeviceTerms' && (
                    <DeviceTerms
                        handleHeaderCancel={handleLoginCLose}
                    />
                )}

                {currentPage === "TwoYearCoverageLogin" && (
                    <TwoYearCoverageLogin
                        ref={childRef}
                        handleHeaderCancel={handleLoginCLose}
                    />
                )}
            </>

            {(isCemInitiateOTPError || isCemInitiateOTPGenericError) && (
                <ErrorModal
                    id='duplicate-shopping-cartId'
                    rtl={rtl}
                    description={''}
                    title={isCemInitiateOTPError ? t('contact_not_match') : t('Try_again', { source_code: t(errorCode) })}
                    firstButtonText={t('got_it')}
                    secButtonText={''}
                    modalFirstButtonClick={handleModalGotIt}
                />
            )}

            {isLoginOTPError && (
                <ErrorModal
                    id={'not-a-mobily-number'}
                    rtl={rtl}
                    title={isLoginStatusCode ? t('login_x2') : t('login_x1')}
                    description={''}
                    firstButtonText={t('got_it')}
                    modalFirstButtonClick={handleTryAgain}
                />
            )}

            <ConfirmModal
                id="discardAppleCareModal"
                idBtn="discardAppleCareModalContinue"
                idCloseIcon="discardAppleCareModalClose"
                showModal={showDiscardAppleCare}
                title={t("Discard_AppleCare_coverage")}
                subTitle={t("if_you_go_back")}
                subText={""}
                buttonName={t("CONTINUE_WITH_COVERAGE")}
                outlineButtonName={t("DISCARD_COVERAGE")}
                onclickButton={() => { setShowDiscardAppleCare(false) }}
                onclickOutLineButton={() => { setShowDiscardAppleCare(false); dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'cartPage' } }) }}
                showOutlineButton={true}
                showIcon={false}
            ></ConfirmModal>

        </>
    )
}

export default Pages